export const SET_USER_GUIDES = 'SET_USER_GUIDES'
export const ADD_USER_GUIDE = 'ADD_USER_GUIDE'
export const DELETE_USER_GUIDE = 'DELETE_USER_GUIDE'
export const DELETE_MULTIPLE_USER_GUIDES = 'DELETE_MULTIPLE_USER_GUIDES'
export const SET_SELECT_ALL_STATE = 'SET_SELECT_ALL_STATE'
export const SET_SELECTED_USER_GUIDES = 'SET_SELECTED_USER_GUIDES'
export const SET_TOTAL_USER_GUDIES = 'SET_TOTAL_USER_GUDIES'
export const UPDATE_USER_GUIDE = 'UPDATE_USER_GUIDE'
export const SET_VIEW_USER_GUIDE = 'SET_VIEW_USER_GUIDE'